// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__ZHSi2","title":"Info_title__29OBa","selects":"Info_selects__kY76Z","requiredAsterisk":"Info_requiredAsterisk__1jcmd"};